import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { RouteReuseStrategy } from '@angular/router';
import { IonicStorageModule } from '@ionic/storage-angular';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Ionic2RatingModule } from 'ionic2-rating';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Native Plugins
import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { CallNumber } from '@awesome-cordova-plugins/call-number/ngx';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { Camera } from '@awesome-cordova-plugins/camera/ngx';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { IonicSelectableModule } from 'ionic-selectable';
// Services
import { InterceptorService } from './services/interceptor.service';
// import { LogonPage } from './logon/logon.page';
import { AboutusPage } from './pages/aboutus/aboutus.page';
import { FeedbackPage } from './accounts/feedback/feedback.page';
import { CountrylistPage } from './pages/countrylist/countrylist.page';
import { OtpVerificationPage } from './accounts/otp-verification/otp-verification.page';
import { TermsAndConditionsPage } from './pages/terms-and-conditions/terms-and-conditions.page';

/*import { AddAddressPage } from './accounts/add-address/add-address.page';*/
import { CitylistPage } from './accounts/citylist/citylist.page';
import { EditAddressPage } from './accounts/edit-address/edit-address.page';
import { AddressDefaultPage } from './accounts/address-default/address-default.page';

import {
    pageTransition,
    customAlertEnter, customAlertLeave,
    customModalEnter, customModalLeave,
    customLoaderEnter, customLoaderLeave,
} from './animations/customAnimation';


import { CommonModule } from '@angular/common';
import { SharedModule } from './shared/shared.module';
// Top of file
import { APP_INITIALIZER } from '@angular/core';
import { ConfigService } from './provider/config.service';

// Factory function
export function initializeApp(configService: ConfigService) {
  return () => configService.loadAppSettings();
}

export function setTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        AppComponent,
        AboutusPage,
        //AddAddressPage,
        CitylistPage,
        EditAddressPage,
        AddressDefaultPage,
        FeedbackPage,
        CountrylistPage,
        OtpVerificationPage,
        TermsAndConditionsPage,],
            entryComponents: [
        AboutusPage,
        //AddAddressPage,
        CitylistPage,
        EditAddressPage,
        AddressDefaultPage,
        FeedbackPage,
        CountrylistPage,
        OtpVerificationPage,
        TermsAndConditionsPage
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        Ionic2RatingModule,
        SharedModule,
        IonicStorageModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (setTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        AppRoutingModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:3000'
        }),
        IonicModule.forRoot({
            mode: 'ios',
            animated: true,
            navAnimation: pageTransition,
            alertEnter: customAlertEnter,
            alertLeave: customAlertLeave,
            modalEnter: customModalEnter,
            modalLeave: customModalLeave,
            loadingEnter: customLoaderEnter,
            loadingLeave: customLoaderLeave,
            backButtonIcon: 'arrow-back',
            backButtonText: '',
            swipeBackEnabled: false
        }),
    ],
    providers: [
        ScreenOrientation,
        Network,
        Device,
        Camera,
        CallNumber,
        AppVersion,
        InAppBrowser,
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        // { provide: ErrorHandler, useClass: CustomErrorHandler },
        // { provide: LoggerService, useClass: LoggerService }
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [ConfigService],
            multi: true
          }
    ],
    // exports: [AppButtonComponent],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule { }